import { render, staticRenderFns } from "./individualBusiness.vue?vue&type=template&id=684b8663&scoped=true&"
import script from "./individualBusiness.vue?vue&type=script&lang=js&"
export * from "./individualBusiness.vue?vue&type=script&lang=js&"
import style0 from "./individualBusiness.vue?vue&type=style&index=0&id=684b8663&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b8663",
  null
  
)

export default component.exports